import { atom } from 'jotai';

const navTrayOpenAtom = atom(false);

export { navTrayOpenAtom };
